import { merge } from 'lodash';
import { SafeComponent } from '@fiverr-private/orca';
import { logger, stats } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { STATS_PREFIX } from '../../../constants';

/**
 * @param {React.FC | React.ComponentClass} Component
 * @param {string} componentName
 * @returns {React.FC | React.ComponentClass}
 */
export const SafeWrapper = (Component, componentName) =>
    SafeComponent(Component, (e) => {
        const { url, userId, userAgent, locale } = getContext();
        const details = {
            url,
            userId,
            userAgent,
            locale,
            package: STATS_PREFIX,
        };

        logger.error(merge(e, { details }), { component: componentName });
        stats.count(STATS_PREFIX, `render_error.${componentName}`);
    });
